// src/ExchangeIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ExchangeIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "19",
    height: "22",
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.81787 10.7579C2.47513 10.7581 3.01497 11.2978 3.01514 11.9551V15.044C3.01514 15.9215 3.73141 16.6377 4.60889 16.6377H14.5933L13.6978 15.7422C13.2328 15.2772 13.2329 14.5139 13.6978 14.0489C14.1628 13.5839 14.9261 13.5839 15.3911 14.0489L18.3306 16.9883C18.4486 17.1063 18.5275 17.2364 18.5835 17.3624C18.6509 17.5141 18.6821 17.6769 18.6821 17.835C18.6821 17.9931 18.6508 18.156 18.5835 18.3077C18.5275 18.4337 18.4486 18.5637 18.3306 18.6817L15.3911 21.6211C15.1529 21.8594 14.8467 21.9727 14.5444 21.9727C14.2422 21.9727 13.936 21.8594 13.6978 21.6211C13.2331 21.1561 13.233 20.3937 13.6978 19.9288L14.5933 19.0333H4.60889C2.40694 19.0333 0.619629 17.2459 0.619629 15.044V11.9551C0.619792 11.2977 1.16039 10.7579 1.81787 10.7579ZM2.52588 15.2579C2.52712 15.27 2.53029 15.2819 2.53174 15.294C2.52975 15.2774 2.5265 15.2609 2.5249 15.2442L2.52588 15.2579Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.91064 1.32134C4.37569 0.856449 5.13898 0.856407 5.604 1.32134C6.06902 1.78635 6.06892 2.54963 5.604 3.0147L4.7085 3.91021H14.6929C16.8948 3.91021 18.6821 5.69757 18.6821 7.89947V10.9874C18.6821 11.6449 18.1415 12.1856 17.4839 12.1856C16.8265 12.1854 16.2866 11.6448 16.2866 10.9874V7.89947C16.2866 7.02203 15.5703 6.30572 14.6929 6.30572H4.7085L5.604 7.20122C6.069 7.66626 6.06897 8.42953 5.604 8.89458C5.36576 9.13283 5.05952 9.24515 4.75732 9.24517C4.45512 9.24517 4.1489 9.13282 3.91064 8.89458L0.971191 5.95513C0.853206 5.83713 0.774261 5.70709 0.718262 5.58111C0.650875 5.42945 0.619687 5.26658 0.619629 5.10845C0.619643 4.95019 0.650801 4.78661 0.718262 4.63482C0.774265 4.50887 0.853232 4.37973 0.971191 4.26177L3.91064 1.32134ZM18.1782 11.0215C18.1739 11.1026 18.1575 11.1801 18.1274 11.252C18.1442 11.2119 18.1585 11.1703 18.1675 11.127L18.1782 11.0215ZM5.25049 8.54107L5.32959 8.44634C5.33098 8.44434 5.33116 8.44152 5.33252 8.43951C5.30845 8.47511 5.28186 8.50968 5.25049 8.54107ZM18.1636 7.54302C18.1695 7.60154 18.1742 7.66044 18.1772 7.71978L18.1636 7.54302C18.1576 7.48431 18.1509 7.42603 18.1421 7.36822L18.1636 7.54302ZM5.25049 2.66118L5.32959 2.56646C5.33098 2.56445 5.33116 2.56164 5.33252 2.55962C5.30845 2.59524 5.28186 2.62979 5.25049 2.66118ZM16.8013 11.127C16.8095 11.1668 16.8225 11.2051 16.8374 11.2422C16.8216 11.2027 16.809 11.1616 16.8003 11.1192L16.8013 11.127Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var ExchangeIcon_default = ExchangeIcon;

export {
  ExchangeIcon_default
};
